import { useCurrentUser, type PlanInterface } from "@beholos/holoscommon";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { useEffect } from "react";
import confetti from "canvas-confetti";
import type { SelectedOptionType } from "./PaymentModal";

export const PaymentModalStep3 = (
  {
    selectedPaymentOption,
    selectedPlan, 
    selectedOption
  }: {
    selectedPaymentOption: 'today' | 'nextCycle',
    selectedPlan?: PlanInterface | null,
    selectedOption: SelectedOptionType
  }
) => {
  const { user } = useCurrentUser();

  useEffect(() => {
    // fire confetti from both bottom corners like a pair of cannons
    const duration = 1500;
    const end = Date.now() + duration;

    (function frame() {
      confetti({
        particleCount: 4,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 1 },
      });
      confetti({
        particleCount: 4,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 1 },
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  }, []);

  const isPlanPurchase = selectedPlan !== null && selectedPlan !== undefined;
  const creditsCount = isPlanPurchase ? selectedPlan.numberOfPasses : selectedOption;
  
  const getEffectiveDate = () => {
    if (!isPlanPurchase) {
      return new Date();
    }
    
    if (selectedPaymentOption === 'today') {
      return new Date();
    } else {
      return user?.nextCycle ? new Date(user.nextCycle) : new Date();
    }
  };
  
  const effectiveDate = getEffectiveDate();
  const formattedDate = format(effectiveDate, 'dd/MM/yyyy', { locale: es });
  
  const getConfirmationMessage = () => {
    if (!isPlanPurchase) {
      return `¡Tu compra ha sido confirmada, tus ${creditsCount} créditos están disponibles ahora mismo!`;
    }
    
    if (selectedPaymentOption === 'today') {
      return `¡Tu compra ha sido confirmada, verás tu plan actualizado inmediatamente!`;
    } else {
      return `¡Tu compra ha sido confirmada, verás tu plan actualizado el día ${formattedDate}.`;
    }
  };
  
  const getBottomMessage = () => {    
    if (selectedPaymentOption === 'today') {
      return `Ahora podrás disfrutar de tu plan ${selectedPlan?.name}.`;
    } else {
      return `A partir del ${formattedDate} podrás disfrutar de tu plan ${selectedPlan?.name}.`;
    }
};
  
  return (
    <div className="py-5 max-h-[80vh] overflow-y-auto">
      <img
        className="w-90 h-auto mx-auto"
        src="https://image.beholos.com/filters:quality(70)format(webp)/img/holos/landing/mujer-gato005.webp"
      />
      <div className="px-6 pb-6 mt-[-20px] border-t-2 border-gray-300">
        <div className="font-bold text-lg my-5">
          {user?.firstname},
          <br />
          {getConfirmationMessage()}
        </div>
        <div className="text-sm">
          {getBottomMessage()}
        </div>

        <a
          href="/user/clases"
          className="btn text-white bg-black border border-black px-6 py-1 rounded-full hover:bg-black/80 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed mt-6 inline-block"
        >
          Busca una clase para reservar
        </a>
      </div>
    </div>
  );
}